import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface LowFrequencyLiveEmpFilters {
  empName: string
  dayRange: string | number
  maxWatchDays: string | number
}

export interface LowFrequencyLiveEmpRecord {
  id?: string | number
  channelName: string
  deptName: string
  empName: string
  consumerWxUnionId: string
  consumerNickName: string
  accessTime: string
  ip: string
  duration: number
  wechatEmpsStr: string
}

export interface LowFrequencyLiveEmpEmployee {
  realName: string
}

function buildParams(query: PageQuery<LowFrequencyLiveEmpFilters>) {
  return {
    ...query.filters,
    pageNo: query.pageNo,
    pageSize: query.pageSize
  }
}

function requireArray<T>(payload: unknown, label: string): T[] {
  if (!Array.isArray(payload)) throw new Error(`${label}响应必须是数组`)
  return payload as T[]
}

async function requireExportFile(blob: Blob) {
  if (!blob.type.includes('application/json')) return blob
  const payload = JSON.parse(await blob.text()) as { message?: string }
  throw new Error(payload.message || '导出失败')
}

export async function fetchLowFrequencyLiveEmpPage(
  query: PageQuery<LowFrequencyLiveEmpFilters>,
  signal: AbortSignal
): Promise<PageResult<LowFrequencyLiveEmpRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/lowFrequencyLiveEmp/queryByCondition',
    params: buildParams(query),
    signal
  })
  return normalizePageResult<LowFrequencyLiveEmpRecord>(payload)
}

export async function fetchLowFrequencyLiveEmpEmployees(): Promise<
  LowFrequencyLiveEmpEmployee[]
> {
  const payload = await requestV2.get<unknown>({
    url: '/main/employee/queryEmpList'
  })
  return requireArray<LowFrequencyLiveEmpEmployee>(payload, '员工列表')
}

export function exportLowFrequencyLiveEmp(
  query: PageQuery<LowFrequencyLiveEmpFilters>
) {
  return requestV2
    .get<Blob>({
      url: '/main/lowFrequencyLiveEmp/download',
      params: buildParams(query),
      responseType: 'blob'
    })
    .then(requireExportFile)
}
